import { Component, Element, Event, EventEmitter, h, Host, Prop } from "@stencil/core";
import { throttle } from "../../utils/throttle";

@Component({
    tag: "ux-infinite-scroll-sensor",
    shadow: false
})
export class InfiniteScrollSensor {
    @Element() sensor: HTMLUxInfiniteScrollSensorElement;
    /** is called when it is scrolled into view */
    @Event({ eventName: "uxInfiniteScrollSensorScrolledIntoView" })
    scrolledIntoView: EventEmitter;
    /** is true after the event was fired. This prevents the event from firing again. set this to false to re-enable the event */
    /* eslint-disable-next-line */
    @Prop({ reflect: true }) hasFired: boolean = false;
    /** this name will also be in the event */
    @Prop({ reflect: true }) readonly name: string = "";

    private onScroll = throttle(() => {
        if (!this.hasFired && this.sensor !== null && isInView(this.sensor)) {
            this.hasFired = true;
            this.scrolledIntoView.emit(this.name);
        }
    }, 100);

    connectedCallback() {
        document.addEventListener("scroll", this.onScroll, true);
    }

    disconnectedCallback() {
        document.removeEventListener("scroll", this.onScroll);
    }

    render() {
        return <Host class="ux-infinite-scroll-sensor"></Host>;
    }
}

function isInView(el: HTMLElement) {
    const box = el.getBoundingClientRect();
    return box.top < window.innerHeight && box.bottom >= 0;
}
